<!--
 * @Description: 项目根组件
 * @Author: hai-27
 * @Date: 2020-02-07 16:23:00
 * @LastEditors: hai-27
 * @LastEditTime: 2020-04-05 13:14:48
-->
<template>
  <div id="app" name="app">
    <el-container>
      <!-- 移动端顶部导航栏 -->
      <div class="mobile-nav md:hidden">
        <div class="mobile-nav-content">
          <el-button icon="el-icon-menu" @click="mobileMenuVisible = true" class="menu-btn"></el-button>
          <router-link to="/" class="mobile-logo">
            <svg style="transform: translateY(10px);" class="footer-box-icon" viewBox="0 0 48 48"
              xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
              <path fill="#ff6700"
                d="M24 6L8 15v18l16 9 16-9V15L24 6zm0 4.2l11.2 6.3L24 22.8 12.8 16.5 24 10.2zM12 28.2l10 5.6v9.4l-10-5.6v-9.4zm14 15v-9.4l10-5.6v9.4l-10 5.6z" />
            </svg>
            <span style="transform: translateY(-10px);">{{ $t('app.logo') }}</span>
            </router-link>
          <el-badge :value="getNum" :hidden="getNum === 0" class="mobile-cart">
            <router-link to="/shoppingCart">
              <i class="el-icon-shopping-cart-full"></i>
            </router-link>
          </el-badge>
        </div>
        <!-- 搜索栏 -->
        <div class="mobile-search">
          <el-input :placeholder="$t('app.search')" v-model="search" size="small">
            <el-button slot="append" icon="el-icon-search" @click="searchClick"></el-button>
          </el-input>
        </div>
      </div>
      <!-- 移动端侧边栏 -->
      <el-drawer :visible.sync="mobileMenuVisible" direction="ltr" size="70%" class="md:hidden">
        <div class="mobile-sidebar">

          <div class="sidebar-user" v-if="!this.$store.getters.getUser">
            <el-button type="primary" @click="login">{{ $t('app.login') }}</el-button>
            <el-button @click="register = true">{{ $t('app.register') }}</el-button>
          </div>
          <div class="sidebar-user logged-in" v-else>
            <span>{{ $t('app.welcome') }} {{ userName }}</span>
            <el-button type="danger" size="mini" @click="logout">{{ $t('app.logout') }}</el-button>
          </div>
          <el-menu :default-active="activeIndex" router class="sidebar-menu">
            <el-menu-item index="/">
              <i class="el-icon-s-home"></i>
              {{ $t('app.home') }}
            </el-menu-item>
            <el-menu-item index="/order">
              <i class="el-icon-s-order"></i>
              {{ $t('app.myOrders') }}
            </el-menu-item>
            <el-menu-item index="/collect">
              <i class="el-icon-star-off"></i>
              {{ $t('app.myFavorites') }}
            </el-menu-item>
          </el-menu>
          <div class="sidebar-lang">
            <p class="lang-label">{{ $t('lang.currentLang') }}</p>
            <div class="lang-seg">
              <el-radio-group :value="$i18n.locale" @input="handleLocaleChange" size="medium">
                <el-radio-button label="zh">中文</el-radio-button>
                <el-radio-button label="en">EN</el-radio-button>
                <el-radio-button label="vi">VI</el-radio-button>
              </el-radio-group>
            </div>
          </div>
        </div>
      </el-drawer>

      <!-- 顶部导航栏 (桌面端) -->
      <div class="topbar hidden md:block">
        <div class="nav">
          <ul>
            <li v-if="!this.$store.getters.getUser" class="nav-item">
              <el-button type="text" @click="login">{{ $t('app.login') }}</el-button>
              <span class="sep">|</span>
              <el-button type="text" @click="register = true">{{ $t('app.register') }}</el-button>
            </li>
            <li v-else class="nav-item">
              <span class="user-welcome">
                {{ welcomeText }}
                <el-popover placement="top" width="180" v-model="visible">
                  <p>{{ $t('app.confirmLogout') }}</p>
                  <div style="text-align: right; margin: 10px 0 0">
                    <el-button size="mini" type="text" @click="visible = false">{{ $t('app.cancel') }}</el-button>
                    <el-button type="primary" size="mini" @click="logout">{{ $t('app.confirm') }}</el-button>
                  </div>
                  <el-button type="text" slot="reference" class="user-name">{{ userName }}</el-button>
                </el-popover>
              </span>
            </li>
            <li class="nav-item">
              <router-link to="/order">{{ $t('app.myOrders') }}</router-link>
            </li>
            <li class="nav-item">
              <router-link to="/collect">{{ $t('app.myFavorites') }}</router-link>
            </li>
            <li :class="getNum > 0 ? 'shopCart-full' : 'shopCart'" class="nav-item">
              <router-link to="/shoppingCart">
                <i class="el-icon-shopping-cart-full"></i> {{ $t('app.shoppingCart') }}
                <span class="num">({{ getNum }})</span>
              </router-link>
            </li>
            <li>
              <el-dropdown @command="handleLocaleChange" trigger="click">
                <span class="lang-switch">
                  <i class="el-icon-globe"></i> {{ currentLocaleLabel }}
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="zh" :disabled="$i18n.locale === 'zh'">中文</el-dropdown-item>
                  <el-dropdown-item command="en" :disabled="$i18n.locale === 'en'">English</el-dropdown-item>
                  <el-dropdown-item command="vi" :disabled="$i18n.locale === 'vi'">Vietnamese</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </li>
          </ul>
        </div>
      </div>
      <!-- 顶部导航栏END -->

      <!-- 顶栏容器 (桌面端) -->
      <el-header class="hidden md:block">
        <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" active-text-color="#409eff"
          router>
          <div class="logo">
            <router-link to="/">
              <svg style="transform: translateY(10px);" class="footer-box-icon" viewBox="0 0 48 48"
                xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <path fill="#ff6700"
                  d="M24 6L8 15v18l16 9 16-9V15L24 6zm0 4.2l11.2 6.3L24 22.8 12.8 16.5 24 10.2zM12 28.2l10 5.6v9.4l-10-5.6v-9.4zm14 15v-9.4l10-5.6v9.4l-10 5.6z" />
              </svg>
              <span class="footer-brand-name">{{ $t('app.logo') }}</span>
            </router-link>
          </div>
          <el-menu-item index="/">{{ $t('app.allGoods') }}</el-menu-item>
          <!-- <el-menu-item index="/luckyWheel">{{ $t('app.luckyWheel') }}</el-menu-item> -->
          <el-menu-item index="/about">{{ $t('app.aboutUs') }}</el-menu-item>

          <div class="so">
            <el-input :placeholder="$t('app.search')" v-model="search">
              <el-button slot="append" icon="el-icon-search" @click="searchClick"></el-button>
            </el-input>
          </div>
        </el-menu>
      </el-header>
      <!-- 顶栏容器END -->

      <!-- 登录模块 -->
      <MyLogin></MyLogin>
      <!-- 注册模块 -->
      <MyRegister :register="register" @fromChild="isRegister"></MyRegister>

      <!-- 主要区域容器 -->
      <el-main>
        <keep-alive>
          <router-view></router-view>
        </keep-alive>
      </el-main>
      <!-- 主要区域容器END -->

      <!-- 底栏容器 -->
      <el-footer>
        <div class="footer footer--site">
          <div class="footer-main">
            <div class="footer-col footer-col--brand">
              <div class="footer-logo-row">
                <svg class="footer-box-icon" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                  <path fill="#ff6700"
                    d="M24 6L8 15v18l16 9 16-9V15L24 6zm0 4.2l11.2 6.3L24 22.8 12.8 16.5 24 10.2zM12 28.2l10 5.6v9.4l-10-5.6v-9.4zm14 15v-9.4l10-5.6v9.4l-10 5.6z" />
                </svg>
                <span class="footer-brand-name">{{ $t('app.logo') }}</span>
              </div>
              <p class="footer-slogan">{{ $t('app.footer.slogan') }}</p>
            </div>
            <div class="footer-col">
              <h4 class="footer-heading">{{ $t('app.footer.aboutColumnTitle') }}</h4>
              <ul class="footer-links">
                <li><router-link to="/about">{{ $t('app.aboutUs') }}</router-link></li>
                <li><router-link to="/privacy">{{ $t('app.footer.privacy') }}</router-link></li>
                <li><router-link to="/service-refund">{{ $t('app.footer.serviceRefund') }}</router-link></li>
              </ul>
            </div>
            <div class="footer-col">
              <h4 class="footer-heading">{{ $t('app.footer.infoTitle') }}</h4>
              <ul class="footer-links">
                <li><router-link to="/return-policy">{{ $t('app.footer.refundReturnPolicy') }}</router-link></li>
                <li><router-link to="/shipping-policy">{{ $t('app.footer.logisticsPolicy') }}</router-link></li>
              </ul>
            </div>
            <div class="footer-col footer-col--contact">
              <h4 class="footer-heading footer-heading--muted">{{ $t('app.footer.contactUs') }}</h4>
              <div class="footer-social">
                <a class="footer-social-btn footer-social-btn--fb" href="https://www.facebook.com/" target="_blank"
                  rel="noopener noreferrer" :aria-label="$t('app.footer.socialFacebook')">
                  <svg viewBox="0 0 24 24" aria-hidden="true">
                    <path fill="currentColor"
                      d="M13.5 22v-8.5h2.9l.4-3.4H13.5V8.1c0-1 .3-1.7 1.8-1.7h1.9V3.3c-.3 0-1.4-.1-2.7-.1-2.7 0-4.5 1.6-4.5 4.6v2.6H7v3.4h3v8.5h3.5z" />
                  </svg>
                </a>
                <a class="footer-social-btn footer-social-btn--yt" href="https://www.youtube.com/" target="_blank"
                  rel="noopener noreferrer" :aria-label="$t('app.footer.socialYoutube')">
                  <svg viewBox="0 0 24 24" aria-hidden="true">
                    <path fill="currentColor"
                      d="M21.6 7.2s-.2-1.6-.9-2.2c-.8-.9-1.7-.9-2.1-1C15.7 3.5 12 3.5 12 3.5h0s-3.7 0-6.6.5c-.4.1-1.3.1-2.1 1-.7.6-.9 2.2-.9 2.2S2 9.1 2 11v.9c0 1.9.4 3.8.4 3.8s.2 1.6.9 2.2c.8.9 1.9.9 2.4 1 1.7.2 7.2.5 7.2.5s3.7 0 6.6-.5c.4-.1 1.3-.1 2.1-1 .7-.6.9-2.2.9-2.2s.4-1.9.4-3.8V11c0-1.9-.4-3.8-.4-3.8zM10 14.7V8.7l5.8 3-5.8 3z" />
                  </svg>
                </a>
              </div>
            </div>
          </div>
          <div class="footer-bottom">
            <p class="footer-copyright">{{ $t('app.footer.copyright') }}</p>
          </div>
        </div>
      </el-footer>
      <!-- 底栏容器END -->
    </el-container>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { mapGetters } from "vuex";
import { setLocale } from "./i18n";

export default {
  beforeUpdate() {
    this.activeIndex = this.$route.path;
  },
  data() {
    return {
      activeIndex: "",
      search: "",
      register: false,
      visible: false,
      mobileMenuVisible: false
    };
  },
  created() {
    if (localStorage.getItem("user")) {
      this.setUser(JSON.parse(localStorage.getItem("user")));
    }
  },
  computed: {
    ...mapGetters(["getUser", "getNum"]),
    currentLocaleLabel() {
      if (this.$i18n.locale === 'zh') return '中文';
      if (this.$i18n.locale === 'vi') return 'Tiếng Việt';
      return 'EN';
    },
    welcomeText() {
      return this.$t('app.welcome');
    },
    userName() {
      return this.getUser ? this.getUser.userName : '';
    }
  },
  watch: {
    getUser: function (val) {
      if (val === "") {
        this.setShoppingCart([]);
      } else {
        this.$axios
          .post("/api/user/shoppingCart/getShoppingCart", {
            user_id: val.user_id
          })
          .then(res => {
            if (res.data.code === "001") {
              this.setShoppingCart(res.data.shoppingCartData);
            } else {
              this.notifyError(res.data.msg);
            }
          })
          .catch(err => {
            return Promise.reject(err);
          });
      }
    }
  },
  methods: {
    ...mapActions(["setUser", "setShowLogin", "setShoppingCart"]),
    handleLocaleChange(locale) {
      if (typeof locale === 'string') {
        setLocale(locale);
      } else if (locale && locale.target && locale.target.value) {
        setLocale(locale.target.value);
      }
    },
    login() {
      this.mobileMenuVisible = false;
      this.setShowLogin(true);
    },
    logout() {
      this.visible = false;
      this.mobileMenuVisible = false;
      localStorage.setItem("user", "");
      this.setUser("");
      this.notifySucceed(this.$t('app.logout') + this.$t('common.success'));
    },
    isRegister(val) {
      this.register = val;
    },
    searchClick() {
      if (this.search != "") {
        this.$router.push({ path: "/", query: { search: this.search } });
        this.search = "";
      }
    }
  }
};
</script>

<style>
/* 全局CSS */
* {
  padding: 0;
  margin: 0;
  border: 0;
  list-style: none;
  box-sizing: border-box;
}

#app .el-header {
  padding: 0;
}

#app .el-main {
  min-height: 300px;
  padding: 20px 0;
}

#app .el-footer {
  padding: 0;
}

a,
a:hover {
  text-decoration: none;
}

/* 全局CSS END */

/* 顶部导航栏CSS */
.topbar {
  height: 40px;
  background-color: #3d3d3d;
  margin-bottom: 20px;
  position: relative;
  z-index: 100;
}

.topbar .nav {
  width: 1225px;
  margin: 0 auto;
}

@media (max-width: 768px) {
  .topbar .nav {
    width: 100%;
  }
}

.topbar .nav ul {
  float: right;
  display: flex;
  align-items: center;
  height: 40px;
}

.topbar .nav li {
  float: left;
  height: 40px;
  color: #b0b0b0;
  font-size: 14px;
  text-align: center;
  line-height: 40px;
  margin-left: 20px;
}

.topbar .nav li a {
  color: #b0b0b0;
}

.topbar .nav a:hover {
  color: #fff;
}

.topbar .nav .user-welcome .user-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.topbar .nav .shopCart {
  background: #424242;
}

.topbar .nav .shopCart:hover {
  background: #fff;
}

.topbar .nav .shopCart:hover a {
  color: #ff6700;
}

.topbar .nav .shopCart-full {
  background: #ff6700;
}

.topbar .nav .shopCart-full a {
  color: white;
}

/* 顶部导航栏CSS END */

/* 移动端导航CSS */
.mobile-nav {
  background: #ffffff;
  padding: 10px 12px 8px;
  border-bottom: 1px solid #eeeeee;
  position: sticky;
  top: 0;
  z-index: 100;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
}

.mobile-nav-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.mobile-nav .menu-btn {
  border: none;
  background: transparent;
  font-size: 22px;
  color: #333;
  padding: 4px 8px;
}

.mobile-nav .menu-btn:hover,
.mobile-nav .menu-btn:focus {
  background: #f5f5f5;
  color: #ff6700;
}

.mobile-logo {
  font-size: 20px;
  font-weight: bold;
  color: #ff6700;
  letter-spacing: -0.5px;
}

.mobile-cart {
  font-size: 20px;
}

.mobile-cart>>>.el-badge__content {
  background-color: #ff6700;
  border: none;
}

.mobile-cart a {
  color: #606266;
  display: flex;
  align-items: center;
  padding: 4px 8px;
  border-radius: 4px;
}

.mobile-cart a:hover {
  background: #f5f5f5;
  color: #ff6700;
}

.mobile-search {
  margin-top: 8px;
}

.mobile-search .el-input__inner {
  border-radius: 18px;
  background: #f5f5f5;
  border-color: transparent;
  font-size: 13px;
}

.mobile-search .el-input__inner:focus {
  background: #fff;
  border-color: #ff6700;
}

/* 移动端侧边栏 */
.mobile-sidebar {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.sidebar-header {
  padding: 15px;
  background: #f5f5f5;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #e0e0e0;
}

.sidebar-user {
  padding: 14px 16px;
  border-bottom: 1px solid #f0f0f0;
  background: #fafafa;
  display: flex;
  gap: 8px;
  align-items: center;
}

.sidebar-user.logged-in {
  justify-content: space-between;
  font-size: 13px;
  color: #333;
}

.sidebar-user.logged-in .el-button--danger {
  background: #ff3b30;
  border-color: #ff3b30;
}

.sidebar-menu {
  flex: 1;
  overflow-y: auto;
}

.sidebar-menu>>>.el-menu-item {
  font-size: 14px;
  color: #333;
  height: 48px;
  line-height: 48px;
}

.sidebar-menu>>>.el-menu-item i {
  color: #ff6700;
  margin-right: 8px;
}

.sidebar-menu>>>.el-menu-item:hover,
.sidebar-menu>>>.el-menu-item.is-active {
  background: #fff5ee;
  color: #ff6700;
}

.sidebar-menu>>>.el-menu-item:hover i,
.sidebar-menu>>>.el-menu-item.is-active i {
  color: #ff6700;
}

.sidebar-lang {
  padding: 16px;
  border-top: 1px solid #f0f0f0;
}

.lang-label {
  font-size: 12px;
  color: #999;
  margin-bottom: 10px;
  font-weight: 500;
}

.lang-seg {
  display: flex;
  justify-content: center;
}

.lang-seg .el-radio-group {
  width: 100%;
  display: flex;
  border: 1px solid #dcdfe6;
  border-radius: 6px;
  overflow: hidden;
}

.lang-seg .el-radio-button {
  flex: 1;
}

.lang-seg .el-radio-button__inner {
  width: 100%;
  border: none !important;
  border-radius: 0 !important;
  font-size: 13px;
  padding: 8px 4px;
  background: #fff;
  color: #606266;
  box-shadow: none !important;
}

.lang-seg .el-radio-button__orig-radio:checked+.el-radio-button__inner {
  background: #ff6700;
  color: #fff;
  border-color: #ff6700;
}

/* 移动端导航CSS END */

/* 顶栏容器CSS */
.el-header .el-menu {
  max-width: 1225px;
  margin: 0 auto;
}

.el-header .logo {
  height: 60px;
  width: 189px;
  float: left;
  margin-right: 100px;
}

.el-header .so {
  margin-top: 10px;
  width: 300px;
  float: right;
}

/* 顶栏容器CSS END */

/* 底栏容器CSS */
.footer--site {
  width: 100%;
  background: #fff;
  border-top: 1px solid #e8e8e8;
  text-align: left;
}

.footer-main {
  max-width: 1225px;
  margin: 0 auto;
  padding: 48px 24px 36px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 32px 48px;
}

.footer-col {
  flex: 1 1 160px;
  min-width: 140px;
}

.footer-col--brand {
  flex: 1.2 1 220px;
  max-width: 280px;
}

.footer-logo-row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
}

.footer-box-icon {
  width: 40px;
  height: 40px;
  flex-shrink: 0;
}

.footer-brand-name {
  font-size: 22px;
  font-weight: 700;
  color: #ff6700;
  letter-spacing: 0.02em;
}

.footer-slogan {
  font-size: 13px;
  color: #666;
  line-height: 1.6;
  max-width: 260px;
}

.footer-heading {
  font-size: 15px;
  font-weight: 700;
  color: #1a1a1a;
  margin: 0 0 18px;
}

.footer-heading--muted {
  font-weight: 600;
  color: #888;
}

.footer-links {
  list-style: none;
  margin: 0;
  padding: 0;
}

.footer-links li {
  margin-bottom: 14px;
}

.footer-links li:last-child {
  margin-bottom: 0;
}

.footer-links a {
  font-size: 14px;
  color: #333;
  transition: color 0.2s;
}

.footer-links a:hover {
  color: #ff6700;
}

.footer-col--contact .footer-social {
  display: flex;
  gap: 12px;
  margin-top: 4px;
}

.footer-social-btn {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.2s, transform 0.2s;
}

.footer-social-btn:hover {
  opacity: 0.9;
  transform: scale(1.05);
}

.footer-social-btn svg {
  width: 22px;
  height: 22px;
}

.footer-social-btn--fb {
  background: #1877f2;
  color: #fff;
}

.footer-social-btn--yt {
  background: #ff0000;
  color: #fff;
}

.footer-bottom {
  border-top: 1px solid #eee;
  padding: 16px 24px 24px;
  text-align: center;
}

.footer-copyright {
  font-size: 12px;
  color: #999;
  margin: 0;
}

@media (max-width: 768px) {
  .footer-main {
    padding: 32px 16px 24px;
    flex-direction: column;
    gap: 28px;
  }

  .footer-col--brand {
    max-width: none;
  }

  .footer-brand-name {
    font-size: 20px;
  }
}

/* 底栏容器CSS END */

/* 响应式容器宽度 */
@media (max-width: 768px) {
  .el-header .el-menu {
    max-width: 100%;
  }

  .el-header .logo {
    width: auto;
    margin-right: 10px;
  }

  .el-header .logo span {
    font-size: 18px;
  }

  .el-header .so {
    width: 150px;
  }

  #app .el-main {
    padding: 10px 0;
  }
}
</style>
